const shadow = {
  boxShadow1: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
};
export default shadow;
